import React, { useState } from 'react';
import LiveSiteViewer from '../realisations/LiveSiteViewer';
import './ClientProjectCard.css';

const ClientProjectCard = ({ project }) => {
    const [isOpen, setIsOpen] = useState(true);

    // Helper for status
    const getStatusLabel = (s) => ({
        draft: 'Brouillon',
        active: 'En cours',
        paused: 'En pause',
        done: 'Terminé'
    }[s] || s);

    return (
        <div className={`client-project-card ${!isOpen ? 'collapsed' : ''}`}>
            <div className="project-card-header" onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer' }}>
                <div className="project-title-group">
                    <h3>{project.name}</h3>
                    <div className="project-meta">
                        <span className={`status-badge ${project.status || 'draft'}`}>
                            {getStatusLabel(project.status)}
                        </span>
                        {project.end_date && <span>• Livraison estimée : {new Date(project.end_date).toLocaleDateString()}</span>}
                    </div>
                </div>
                <button className={`accordion-toggle-btn ${isOpen ? 'open' : ''}`}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 9l-7 7-7-7" /></svg>
                </button>
            </div>

            {isOpen && (
                <div className="project-card-body">
                    {project.preview_url ? (
                        <div className="mockup-explanation">
                            <div className="explanation-icon">
                                <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                            </div>
                            <div className="explanation-content">
                                <h4>Accès à votre espace projet</h4>
                                <p>Consultez ci-dessous l'avancement en temps réel. Cette fenêtre interactive vous permet de naviguer dans la maquette ou le site de développement.</p>
                            </div>
                        </div>
                    ) : null}

                    <div className="project-viewer-container">
                        {project.preview_url ? (
                            <LiveSiteViewer url={project.preview_url} label={project.preview_label || "Aperçu du projet"} />
                        ) : (
                            <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>
                                <p>Aucun aperçu disponible pour le moment.</p>
                            </div>
                        )}
                        {project.preview_url && (
                            <div className="project-actions-group">
                                <button className="action-btn-premium btn-copy" onClick={() => {
                                    navigator.clipboard.writeText(project.preview_url);
                                    // Toast notification could be better here, but alert is consistent with previous code for now
                                    alert('Lien copié dans le presse-papier !');
                                }}>
                                    <div className="btn-icon">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                                    </div>
                                    <span>Copier le lien</span>
                                </button>

                                <button className="action-btn-premium btn-open" onClick={() => window.open(project.preview_url, '_blank')}>
                                    <div className="btn-icon">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                                    </div>
                                    <span>Ouvrir le site</span>
                                </button>

                                <button className="action-btn-premium btn-share" onClick={async () => {
                                    if (navigator.share) {
                                        try {
                                            await navigator.share({
                                                title: project.name,
                                                text: `Découvrez le projet ${project.name}`,
                                                url: project.preview_url
                                            });
                                        } catch (err) { console.error('Erreur partage', err); }
                                    } else {
                                        navigator.clipboard.writeText(project.preview_url);
                                        alert('Lien copié pour partage !');
                                    }
                                }}>
                                    <div className="btn-icon">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
                                    </div>
                                    <span>Partager</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <style>{`
                .project-actions-group {
                    display: flex;
                    gap: 12px;
                    margin-top: 16px;
                    flex-wrap: wrap;
                }
                .action-btn-premium {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px 16px;
                    border-radius: 12px;
                    border: 1px solid transparent;
                    font-size: 0.9rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                    background: #f8fafc;
                    color: #64748b;
                }
                .action-btn-premium:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); 
                }
                
                .btn-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                /* Button Variants */
                .btn-copy:hover {
                    background: #eff6ff;
                    color: #3b82f6;
                    border-color: rgba(59, 130, 246, 0.2);
                }
                .btn-open:hover {
                    background: #f0fdf4;
                    color: #10b981;
                    border-color: rgba(16, 185, 129, 0.2);
                }
                .btn-share:hover {
                    background: #f5f3ff;
                    color: #8b5cf6;
                    border-color: rgba(139, 92, 246, 0.2);
                }

                /* Dark Mode Support */
                .dark .action-btn-premium {
                    background: #1e293b;
                    color: #94a3b8;
                    border-color: rgba(255, 255, 255, 0.05);
                }
                .dark .btn-copy:hover { background: rgba(59, 130, 246, 0.15); color: #60a5fa; }
                .dark .btn-open:hover { background: rgba(16, 185, 129, 0.15); color: #34d399; }
                .dark .btn-share:hover { background: rgba(139, 92, 246, 0.15); color: #a78bfa; }
            `}</style>
        </div>
    );
};
export default ClientProjectCard;
